import { ChangeDetectionStrategy, Component, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component(
{
    selector: 'add-or-remove-from-cart-button',
    template: `
        <div class="add-remove-cart" *ngIf="!showPlaceholder; else addToCartButtonPlaceholder" [class.remove]="showRemove" [class.updating]="updating">
            <div class="add-to-cart">
                <button mat-button [disabled]="disabled" (click)="addToCart.next()">
                    <span class="label">Add to Cart</span>
                    <mat-icon class="right">
                        <span class="actual-icon">add_shopping_cart</span>
                        <app-action-button-spinner *ngIf="updating"></app-action-button-spinner>
                    </mat-icon>
                </button>
            </div>
            <button mat-button class="remove-from-cart" [disabled]="disabled" (click)="removeFromCart.next()">
                <span class="label">Remove from Cart</span>
                <mat-icon class="right">
                    <span class="actual-icon">remove_shopping_cart</span>
                    <app-action-button-spinner *ngIf="updating"></app-action-button-spinner>
                </mat-icon>
            </button>
        </div>
        <ng-template #addToCartButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Remove from Cart</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    `,
    styleUrls: ['./add-or-remove-from-cart-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddOrRemoveFromCartButtonComponent
{
    @Input() protected showPlaceholder = false;
    @Input() protected showRemove = false;
    @Input() protected updating = false;

    @Input() protected disabled = false;

    @Output() protected readonly addToCart = new Subject<void>();
    @Output() protected readonly removeFromCart = new Subject<void>();
}
